<template>
  <div class="test-list">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>视频播放记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">

      <div>
        <el-input placeholder="根据手机号搜索" prefix-icon="el-icon-search" size="small" v-model="mobileKey"
          @keyup.enter.native="Query"></el-input>
      </div>

      <div style="margin-right:20px;">
        <el-select v-model="isAgreeKey" placeholder="弹窗是否确定" size="small" clearable>
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="0"></el-option>
        </el-select>
      </div>

      <div>
        <el-input placeholder="根据观看进度搜索" prefix-icon="el-icon-search" size="small" v-model="playGrogress"
          @keyup.enter.native="Query"></el-input>
        <div style="font-size:12px;">*大于等于当前值的数据</div>
      </div>

      <div>
        <el-input placeholder="根据视频名称搜索" prefix-icon="el-icon-search" size="small" v-model="videoNameKey"
          @keyup.enter.native="Query"></el-input>
      </div>
      <div> <el-button type="primary" size="small" @click.native="Query">查询</el-button></div>
      <div style="margin-left:30px;"> <el-button type="success" size="small" @click.native="resetting">重置</el-button>
      </div>

      <div style="margin-left:30px;">
        <!-- <el-button type="success" size="small" @click="gotoUserRecord">查询同意书记录</el-button> -->
      </div>

      <div class="addGame" style="margin-left:30px;" v-if="false">
        <el-button type="success" size="small" @click="downloadRecord">导出记录</el-button>
      </div>
    </div>

    <div class="list">
      <el-collapse v-model="activeName">
        <el-collapse-item v-for="(tableData, key) in userRecordList" :name="key" :title="`用户id: ${key}`" :key="key">
          <el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName" size="small">
            <el-table-column prop="name" label="用户名"></el-table-column>
            <el-table-column prop="mobile" label="手机号"></el-table-column>
            <el-table-column prop="Video_name" label="视频标题"></el-table-column>
            <el-table-column prop="click_OK" label="是否点击弹窗确定" :formatter="clickOKFormatter"></el-table-column>
            <el-table-column prop="play_Percentage" label="观看进度(%)"></el-table-column>
            <el-table-column prop="c_time" label="掉接口时间"></el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>

    </div>

    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
        :page-sizes="[30, 60, 90, 120]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <el-dialog title="选择导出时间范围" :visible.sync="centerDialogVisible" width="400px" center>
      <div align="center" class="time-screen">
        <el-date-picker v-model="time_slot" size="small" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click.native="exportConfirm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
export default {
  data() {
    return {
      userRecordList: {}, // 用户记录列表
      pages: 1, // 页码
      limit: 30, // 每页的数量
      total: 0, // 总数量
      centerDialogVisible: false, // 点击导出记录出现的弹窗
      time_slot: ['', ''], // 日期选择器的日期数组
      mobileKey: '', // 手机号输入框的值
      playGrogress: '',
      isAgreeKey: '',
      activeName: '',
      videoNameKey: '',
    }
  },
  created() {
    // 这里掉接口
    this.getList()
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return '';
      } else {
        return 'success-row';
      }
    },
    // 查询点击事件
    Query() {
      console.log(this.isAgreeKey);
      this.pages = 1;
      this.getList();
    },
    // 重置
    resetting() {
      this.mobileKey = this.playGrogress = this.isAgreeKey = this.activeName = this.videoNameKey = ''
      this.getList();
    },
    // 每页条数改变的数据
    handleSizeChange(val) {
      this.limit = val; // 改变每页数量
      this.getList() // 掉接口重新拉取数据
    },
    handleCurrentChange(val) {
      this.pages = val; // 第几页
      this.getList() // 改变页码
    },
    // 获取页面数据
    getList() {
      this.$get(`/v1/video-record?&page=${this.pages}&limit=${this.limit}&mobile=${this.mobileKey}&click_OK=${this.isAgreeKey}&play_Percentage=${this.playGrogress}&Video_name=${this.videoNameKey}`, {}).then((res) => {
        if (res.data.status === 'success') {
          console.log(res.data.data)
          this.userRecordList = res.data.data;
          this.total = res.data.total; // 设定总记录数
        } else {
          this.$msg(res.data.msg);
        }
      });
    },
    // 导出记录
    downloadRecord() {
      this.centerDialogVisible = true;
    },
    // 按钮确定
    exportConfirm(e) {
      console.log(this.time_slot); // 打印结束日期
      // 处理业务逻辑...
      this.time_slot = ['', '']; // 清空日期选择器
      this.centerDialogVisible = false; // 关闭对话框
      // this.$getFile(`/v1/admin/answer-record/XL?id=${this.export_test_id}&start_time=${this.time_slot[0]}&end_time=${this.time_slot[1]}`, {})
      //   .then((res) => {
      //     if (res.status === 200) {
      //       this.downloadFile(res.data)
      //       this.centerDialogVisible = false
      //     } else {
      //       this.$msg(res.statusText)
      //     }
      //   });
    },
    downloadFile(file) {
      const blob = new Blob([file], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8' }) // 构造一个blob对象来处理数据，并设置文件类型
      if (window.navigator.msSaveOrOpenBlob) { //兼容IE10
        navigator.msSaveBlob(blob, this.filename)
      } else {
        const href = URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
        const a = document.createElement('a') //创建a标签
        a.style.display = 'none'
        a.href = href // 指定下载链接
        a.download = this.export_test_title + '视频播放记录.xlsx' //指定下载文件名
        a.click() //触发下载
        URL.revokeObjectURL(a.href) //释放URL对象
      }
    },
    // 选择器按钮取消
    handleCancel() {
      this.time_slot = ['', '']; // 清空日期选择器
      this.centerDialogVisible = false;
    },
    // 跳转路由页面
    gotoUserRecord() {
      this.$router.push('/user-record');
    },
    // 处理是否同意的枚举
    clickOKFormatter(row, column, cellValue) {
      // cellValue 是当前单元格的值
      return cellValue === 1 ? '是' : '否';
    },
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.el-collapse-item__header.is-active {
  font-size 15px
  color red
}
.el-collapse-item__header {
  font-size 15px
  padding-left 10px
}
 .el-select .el-input {
    width: 200px;
  }
.test-list
    .el-table .warning-row {
      background: oldlace;

    }

    .el-table .success-row {
      background: #f0f9eb;
    }

    .search
      margin 20px 0
      display flex
      justify-content flex-start
      input
        width 200px
        margin-right 20px
      .add
        padding-left 100px

    .list
      min-height 550px
      border 1px solid #EBEEF5
      .edit_icon
        width 20px
        height 20px
        margin-left 16px
        border 1px solid  #ccc
        border-radius 4px


</style>



// WEBPACK FOOTER //
// src/pages/userRecord/playRecord/playRecord.vue